import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'members';
const BASE_PATH = `${API_ROOT}/members`;
const PATHS = {
    DELETE: (memberId) => `${BASE_PATH}/${memberId}`,
    GET: (memberId) => `${BASE_PATH}/${memberId}`,
    INVITE: BASE_PATH,
    LIST: BASE_PATH,
    UPDATE: (memberId) => `${BASE_PATH}/${memberId}`,
    LOGIN_EVENTS: `${API_ROOT}/login_events`,
};
async function get(memberId) {
    return (await (await SecureAxios()).get(PATHS.GET(memberId))).data;
}
function getKey(memberId) {
    return [CacheKey, 'get', memberId];
}
async function delete_(csrfToken, memberId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(memberId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
async function update(csrfToken, memberId, props) {
    const form = new FormData();
    if (props.role)
        form.append('role', props.role);
    return (await (await SecureAxios()).put(PATHS.UPDATE(memberId), form, { headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' } })).data;
}
async function invite(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.INVITE, JSON.stringify(props), {
        headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'application/json' },
    })).data;
}
async function loginEvents(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.memberId)
        params.append('member_id', props.memberId);
    return (await (await SecureAxios()).get(`${PATHS.LOGIN_EVENTS}?${params.toString()}`)).data;
}
function loginEventsKey(props) {
    return [CacheKey, 'loginEvents', props];
}
export default { CacheKey, delete_, get, getKey, invite, list, listKey, loginEvents, loginEventsKey, update };
